import Image from 'next/image';
import { useMemo } from 'react';

import { KeyValueRow, KeyValueTable } from '@/design-system/components/ui';
import useGetChainInfo from '@/hooks/useGetChainInfo';

import { Trigger } from '../../domain';
import { AddressChip } from './components/AddressChip';

interface Props {
  trigger: Trigger;
}

export function FelixCdpCollateralTriggerFullDetails({ trigger }: Props) {
  const { getChainIconUrl } = useGetChainInfo();

  const tokenAddress = useMemo(() => {
    return trigger.context?.tokenAddress || '';
  }, [trigger.context]);

  const networkDisplay = useMemo(() => {
    const chainIconUrl = getChainIconUrl(999);

    return (
      <div className="tw:flex tw:flex-row tw:items-center tw:gap-2">
        {chainIconUrl && <Image src={chainIconUrl} alt="HyperEVM" width={20} height={20} />}
        <span>HyperEVM</span>
      </div>
    );
  }, [getChainIconUrl]);

  const collateralDisplay = useMemo(() => {
    if (!tokenAddress) return '-';

    return <AddressChip address={tokenAddress} chainId={999} />;
  }, [tokenAddress]);

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow label="Collateral Address" value={collateralDisplay} />
      <KeyValueRow label="Network" value={networkDisplay} />
      <KeyValueRow label="Argument conditions" value={trigger.conditionExpression ?? '-'} />
    </KeyValueTable>
  );
}
